<template>
  <WidgetLayout>
    <div class="flex justify-center">
      <div class="w-96 min-h-[500px] bg-white p-4 shadow-md rounded flex">
        <PaymentLink />
      </div>
    </div>
  </WidgetLayout>
</template>

<script setup lang="ts">
import PaymentLink from '@/components/widget/payment/PaymentLink.vue';
import WidgetLayout from '@/layouts/WidgetLayout.vue';
</script>

<style lang="scss" scoped></style>
